module.exports = __webpack_public_path__ + "static/img/introduction-welcome-895957656.5e41eeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-895957656.jpg
// module id = xvZ9
// module chunks = 0